import { Link } from '@primerai/thread';
import styled from 'styled-components';

export const IconWrapper = styled.div`
  height: 44px;
  width: 44px;
  min-width: 44px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  background: linear-gradient(180deg, #333 0%, #333 100%);

  &.analyze {
    background: linear-gradient(180deg, #afb5f7 0%, #515dee 100%);
  }
`;

export const OutlineLink = styled(Link)`
  border: ${({ theme }) => theme.borders.$default};
  border-radius: ${({ theme }) => theme.radii.$large};
  padding: 1rem;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

export const ProductGrid = styled.div`
  & > div:not(:last-child) {
    border-bottom: ${({ theme }) => theme.borders.$default};
  }
`;
